import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import WorkspaceService from '../../services/WorkspaceService';

export const getWorkspaceActivity = createAsyncThunk(
    'workspaceActivity/get',
    async ({ workspaceId, cursor, limit, verb } = {}) => {
        return WorkspaceService.getWorkspaceActivity(workspaceId, { cursor, limit, verb });
    }
);

const initialState = {
    // Map of workspaceId → { items, nextCursor, loading, error }
    byWorkspace: {},
};

export const WorkspaceActivitySlice = createSlice({
    name: 'workspaceActivity',
    initialState,
    reducers: {
        clearActivity: (state, action) => {
            delete state.byWorkspace[action.payload];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWorkspaceActivity.pending, (state, action) => {
                const { workspaceId } = action.meta.arg;
                const existing = state.byWorkspace[workspaceId] || { items: [], nextCursor: null };
                state.byWorkspace[workspaceId] = { ...existing, loading: true, error: null };
            })
            .addCase(getWorkspaceActivity.fulfilled, (state, action) => {
                const { workspaceId, cursor } = action.meta.arg;
                const prev = state.byWorkspace[workspaceId] || { items: [] };
                // Append when paginating (cursor present), replace on fresh load
                const items = cursor
                    ? [...prev.items, ...(action.payload.items || [])]
                    : (action.payload.items || []);
                state.byWorkspace[workspaceId] = {
                    items,
                    nextCursor: action.payload.nextCursor ?? null,
                    loading: false,
                    error: null,
                };
            })
            .addCase(getWorkspaceActivity.rejected, (state, action) => {
                const { workspaceId } = action.meta.arg;
                const existing = state.byWorkspace[workspaceId] || { items: [], nextCursor: null };
                state.byWorkspace[workspaceId] = { ...existing, loading: false, error: action.error.message };
            });
    },
});

export const { clearActivity } = WorkspaceActivitySlice.actions;

export const selectWorkspaceActivity = (workspaceId) => (state) =>
    state.workspaceActivity.byWorkspace[workspaceId] || { items: [], nextCursor: null, loading: false, error: null };

export default WorkspaceActivitySlice.reducer;
